__webpack_require__.p = "/sa/recommendations-fe/";